import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ObjectStatuses } from '@zipari/shared-ds-util-status';
import { DisplayDay } from '../../calendar.model';

@Component({
  selector: 'lib-calendar-day-cell',
  templateUrl: './day-cell.component.html',
  styleUrls: ['./day-cell.component.scss'],
})
export class DayCellComponent {
  @Input() singleDay: DisplayDay;
  @Input() statusses: ObjectStatuses;

  @Output() statusPillClicked = new EventEmitter<any>();
}
